/**
 * TODO: rewrite with state hooks
 */

import * as React from "react";

import { DateTime } from "luxon";

import { SearchDate } from "../../components/molecules";
import { DatePickerCalendar } from "../../components/molecules/date-picker";
import { dateFromIso } from "../../utils/dateIso";

interface IProps {
  disabled?: boolean;
  maxDaysRange?: number;
  maximumMonthsIndexes?: number;
  onClick?(): void;
  onSelectDate(date: string): void;
  trackChange?(value: string | undefined): void;
  selectedDate?: string;
}

interface IState {
  active: boolean;
  isOutsideClicked: boolean;
  firstMonth: boolean;
  lastMonth: boolean;
  selectedMonth: DateTime;
}

class DatePicker extends React.Component<IProps, IState> {
  private readonly currentDate = dateFromIso("now");
  private readonly inputRef = React.createRef<HTMLInputElement>();
  private readonly datePickerRef = React.createRef<HTMLInputElement>();
  private readonly maximumMonthsIndexes = 2;
  private monthScrollCounter = 0;

  public state: IState = {
    active: false,
    isOutsideClicked: false, // workaround for click outside with new react version and race condition
    firstMonth: true,
    lastMonth: false,
    selectedMonth: this.currentDate,
  };

  /**
   * Check if click is outside of a datepicker
   */
  private readonly checkOnBodyClick = (e: MouseEvent) => {
    const ref = this.datePickerRef.current;

    if (ref) {
      this.setState({ isOutsideClicked: true });
    }

    if (!ref?.contains(e.target as Node) && this.state.isOutsideClicked) {
      if (this.state.active) {
        this.props.trackChange?.(
          this.props.selectedDate ? `${this.props.selectedDate}` : undefined,
        );
      }


      this.setState({ active: false, isOutsideClicked: false });
    }
  };

  public componentDidMount(): void {
    if (this.props.selectedDate && this.inputRef.current) {
      this.inputRef.current.value = setDateFormat(this.props.selectedDate);
    }

    document.addEventListener("click", this.checkOnBodyClick);
  }

  public componentWillUnmount(): void {
    document.removeEventListener("click", this.checkOnBodyClick);
  }

  public componentDidUpdate(prevProps: IProps) {
    if (
      this.inputRef.current &&
      prevProps.selectedDate !== this.props.selectedDate &&
      !this.props.selectedDate
    ) {
      this.inputRef.current.value = "";
    }
  }

  /**
   * Show/hide picker
   */
  public toggleDatePicker = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }

    if (this.props.disabled) {
      return;
    }

    // const active = !this.state.active;

    // this.setState({ active });
    this.setState((prevState) => ({
      active: !prevState.active,
    }));
  };

  public onMonthLeft = (): void => {
    if (this.state.firstMonth) {
      return;
    }

    this.monthScrollCounter--;

    const [selectedMonth, firstMonth, lastMonth] = [
      this.state.selectedMonth.minus({ months: 1 }),
      this.monthScrollCounter === 0 ? true : false,
      false,
    ];

    this.setState({ selectedMonth, firstMonth, lastMonth });
  };

  public onMonthRight = (): void => {
    if (this.state.lastMonth) {
      return;
    }

    this.monthScrollCounter++;

    const [selectedMonth, firstMonth, lastMonth] = [
      this.state.selectedMonth.plus({ months: 1 }),
      false,
      this.monthScrollCounter ===
      (this.props.maximumMonthsIndexes || this.maximumMonthsIndexes)
        ? true
        : false,
    ];

    this.setState({ selectedMonth, firstMonth, lastMonth });
  };

  public onSelectDate = (date: DateTime): void => {
    if (this.inputRef.current) {
      const isoDate = date.toISODate();

      this.inputRef.current.value = setDateFormat(isoDate);
      this.props.onSelectDate(isoDate);
      this.setState({ active: false });

      this.props.trackChange?.(`${isoDate}`);
    }
  };

  /**
   * Render calendar
   */
  public render() {
    return (
      <React.Fragment>
        <SearchDate inputRef={this.inputRef} onClick={this.toggleDatePicker}>
          {this.state.active && (
            <DatePickerCalendar
              currentDate={this.currentDate}
              firstMonth={this.state.firstMonth}
              innerRef={this.datePickerRef}
              lastMonth={this.state.lastMonth}
              maxDaysRange={this.props.maxDaysRange}
              onMonthLeft={this.onMonthLeft}
              onMonthRight={this.onMonthRight}
              onSelectDate={this.onSelectDate}
              selectedDate={this.props.selectedDate}
              selectedMonth={this.state.selectedMonth}
            />
          )}
        </SearchDate>
      </React.Fragment>
    );
  }
}

/**
 * Format date to e.g. March 19
 */
function setDateFormat(date: string): string {
  return dateFromIso(date).toFormat("MMMM dd");
}

export { DatePicker };
